import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import axios from 'axios';
import '../App.css';
import { API } from './lib/api';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import ApplicationForm from './pages/ApplicationForm';
import Registry from './pages/Registry';
import StaffReview from './pages/StaffReview';

export default function GuildApp() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <Layout>
      <Routes>
        <Route index element={<Home />} />
        <Route path="apply" element={<ApplicationForm />} />
        <Route path="registry" element={<Registry />} />
        <Route path="staff" element={<StaffReview />} />
      </Routes>
    </Layout>
  );
}